// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PytJ","type":"styles_type__1dcVN","choices":"styles_choices__1pJIw"};